import React from 'react'

const Card = (props) => {
  return (
    <div style={{ width: props.width || "auto"}} className={` rounded-md p-4 h-full shadow-card hover:shadow-lg transition-all duration-300 bg-gradient-card border`}>
      {props.children}
    </div>
  )
}

export default Card